export const repairs = {
  /** Browser tab title (set by the Async component via useAsyncPageDocumentTitle). */
  documentTitle: "Repairs",
};
